import { createTheme } from '@mui/material';

export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#2471b5', // Updated to match --primary-color
      light: '#91badf', // Updated to match --primary-color-light
      contrastText: '#fff',
    },
    secondary: {
      main: '#2633eb', // Updated to match --accent-color
      contrastText: '#fff',
    },
    background: {
      default: '#f7f9fc', // Updated to match --bg-secondary
      paper: '#fff', // Updated to match --bg-primary
    },
    text: {
      primary: '#111827', // Updated to match --text-primary
      secondary: '#dcdcdc', // Updated to match --text-secondary
    },
  },
  typography: {
    fontFamily: [
      'Rubik',
      'Huninn',
      'sans-serif',
    ].join(','),
    h1: {
      fontFamily: [
        'Rubik',
        'Huninn',
        'sans-serif',
      ].join(','),
      fontWeight: 700,
    },
    h2: {
      fontFamily: [
        'Rubik',
        'Huninn',
        'sans-serif',
      ].join(','),
      fontWeight: 700,
    },
    h3: {
      fontFamily: [
        'Rubik',
        'Huninn',
        'sans-serif',
      ].join(','),
      fontWeight: 600,
    },
    h4: {
      fontFamily: [
        'Rubik',
        'Huninn',
        'sans-serif',
      ].join(','),
      fontWeight: 600,
    },
    h5: {
      fontFamily: [
        'Rubik',
        'Huninn',
        'sans-serif',
      ].join(','),
      fontWeight: 600,
    },
    h6: {
      fontFamily: [
        'Rubik',
        'Huninn',
        'sans-serif',
      ].join(','),
      fontWeight: 600,
    },
    fontWeightBold: 800,
    fontWeightMedium: 600,
    fontWeightRegular: 400,
  },
  shape: {
    borderRadius: 16, // more rounded
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 9999, // pill shape
          fontWeight: 600,
          paddingLeft: 24,
          paddingRight: 24,
        },
        containedPrimary: {
          background: 'linear-gradient(145deg, #2633eb 0%, #2633eb 100%)',
          color: '#fff',
        },
        outlined: {
          borderWidth: 2,
          borderColor: '#2633eb',
          color: '#2633eb',
          '&:hover': {
            borderColor: '#2633eb',
            backgroundColor: 'rgba(38, 51, 235, 0.04)',
          },
        },
      },
    },
  },
}); 